module.exports = __webpack_public_path__ + "static/media/takeaway3.4408bae6.png";